import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const ButtonsContainer = styled.div`
  display: flex;
  justify-content: center;
  margin: 30px 0 15px;
`;

const BaseButton = styled.button`
  width: 140px;
  padding: 3px 0;
  border-radius: 3px;
  font-size: 15px;
  font-weight: 600;
`;

export const UpdateButton = styled(BaseButton)`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 18px;
  background-color: ${({ theme }) => theme.orangeBackground};
  color: #FFFFFF;
  border: none;
  border-radius: 15px;
`;

export const CancelButton = styled(BaseButton)`
  background-color: #FFF;
  border: 1px solid #AFAFAF;
  color: #AFAFAF;
  border-radius: 16px;
`;

export const StyledLoader = styled(FontAwesomeIcon)`
  margin-left: 10px;
`;
